import * as actions from './actions'
import reducer from './reducers'
import * as actionTypes from './action-types'
import * as selectors from './selectors'

export { actions, reducer, actionTypes, selectors }



// WEBPACK FOOTER //
// ./src/modules/queues/index.js